// Browser platform adapter — Web Workers. Selected via the "#adapter" browser condition
// (Vite/esbuild/webpack set it by default). The `new Worker(new URL(...), { type: 'module' })`
// form is the idiom bundlers recognize and compile the worker for automatically.

export interface WorkerHandle {
  post(msg: unknown, transfer?: Transferable[]): void
  onMessage(handler: (msg: any) => void): void
  terminate(): Promise<void>
}

export function isSupported(): boolean {
  return typeof Worker !== 'undefined'
}

export function hardwareThreads(): number {
  return globalThis.navigator?.hardwareConcurrency || 4
}

export function spawnWorker(): WorkerHandle {
  const w = new Worker(new URL('./worker.browser.ts', import.meta.url), {
    type: 'module',
  })
  return {
    post: (msg, transfer) => w.postMessage(msg, (transfer as Transferable[]) ?? []),
    onMessage: (handler) =>
      w.addEventListener('message', (e) => handler((e as MessageEvent).data)),
    terminate: async () => w.terminate(),
  }
}
